import {
    GET_LEGS,
    ADD_LEG,
    GET_SINGLE_TRIP,
    REPEAT_WEEKLY,
    EDIT_TRIP,
    DELETE_TRIP,
    CANCEL_TRIP,
    DELETE_LEG,
    CANCEL_LEG,
    GET_LEGS_TOTAL,
    ACCEPT_PENDING_LEG,
    REJECT_PENDING_LEG,
    RECALCULATE_TRIP_REVENUE,
    LEG_ASSIGN_OR_CHANGE_DATA,
    EDIT_LEG_LIST,
    REFRESH_ALL_DATA,
    LEG_CSV_IMPORT,
    UN_CANCEL_LEG,
    CREATE_LEG_NOTE,
    EDIT_LEG_NOTE, DELETE_LEG_NOTE, UN_CANCEL_TRIP, NO_SHOW_LEG, UN_NO_SHOW_LEG
} from "./legs.types";

export const getLegs = (params, noLoad) => {
    return {
        type: GET_LEGS,
        payload: {
            params,
            noLoad: noLoad
        },
    };
};

export const addLeg = (body, requestParams) => {
    return {
        type: ADD_LEG,
        payload: {
            body,
            requestParams
        },
    };
};

export const editLegList = (body) => {
    return {
        type: EDIT_LEG_LIST,
        payload: body,
    };
};

export const deleteLeg = (id, tripId, noLoad = true, requestParams) => {
    return {
        type: DELETE_LEG,
        payload: {
            id,
            tripId,
            noLoad,
            requestParams
        },
    };
};
export const cancelLeg = (id, tripId, noLoad = true, requestParams) => {
    return {
        type: CANCEL_LEG,
        payload: {
            id,
            tripId,
            noLoad,
            requestParams
        },
    };
};

export const unCancelLeg = (id, tripId, noLoad = true, requestParams) => {
    return {
        type: UN_CANCEL_LEG,
        payload: {
            id,
            tripId,
            noLoad,
            requestParams
        },
    };
};

export const noShowLeg = (id, tripId, noLoad = true,requestParams) => {
    return {
        type: NO_SHOW_LEG,
        payload: {
            id,
            tripId,
            noLoad,
            requestParams
        },
    };
};

export const unNoShowLeg = (id, tripId, noLoad = true,requestParams) => {
    return {
        type: UN_NO_SHOW_LEG,
        payload: {
            id,
            tripId,
            noLoad,
            requestParams
        },
    };
};

export const acceptPendingLegs = (body) => {
    return {
        type: ACCEPT_PENDING_LEG,
        payload: {
            body
        },
    };
};

export const rejectPendingLegs = (body) => {
    return {
        type: REJECT_PENDING_LEG,
        payload: {
            body
        },
    };
};

export const getLegsTotals = (params, noLoad) => {
    return {
        type: GET_LEGS_TOTAL,
        payload: {
            params,
            noLoad: noLoad
        },
    };
};

export const legAssignOrChangeData = (id, body, noSuccess, requestParams) => {
    return {
        type: LEG_ASSIGN_OR_CHANGE_DATA,
        payload: {
            id,
            body,
            noSuccess,
            requestParams
        },
    };
};


export const getSingleTrip = (id, params, noLoad = false) => {
    return {
        type: GET_SINGLE_TRIP,
        payload: {
            id,
            params,
            noLoad
        },
    };
};

export const editTrip = (id, body, noLoad = true, requestParams) => {
    return {
        type: EDIT_TRIP,
        payload: {
            id,
            body,
            noLoad,
            requestParams
        },
    };
};

export const deleteTrip = (id, params, noLoad = true, requestParams) => {
    return {
        type: DELETE_TRIP,
        payload: {
            id,
            params,
            noLoad,
            requestParams
        },
    };
};

export const cancelTrip = (id, params, noLoad = true, requestParams) => {
    return {
        type: CANCEL_TRIP,
        payload: {
            id,
            params,
            noLoad,
            requestParams
        },
    };
};
export const unCancelTrip = (id, params, noLoad = true, requestParams) => {
    return {
        type: UN_CANCEL_TRIP,
        payload: {
            id,
            params,
            noLoad,
            requestParams
        },
    };
};

export const refreshAllData = (params, mapView) => {
    return {
        type: REFRESH_ALL_DATA,
        payload: {
            params,
            mapView
        },
    };
};

export const recalculateTripRevenue = (id, body, noLoad = true) => {
    return {
        type: RECALCULATE_TRIP_REVENUE,
        payload: {
            id,
            body,
            noLoad
        },
    };
};

/** CSV */

export const uploadLegCsv = (file, type) => {
    return {
        type: LEG_CSV_IMPORT,
        payload: {
            file,
            type,
        },
    };
};

/** End */


/** Repeat weekly */

export const repeatWeekly = (body) => {
    return {
        type: REPEAT_WEEKLY,
        payload: {
            body,
        },
    };
};

/**Leg Notes */

export const creteLegNote = (legId, body, tripId) => {
    return {
        type: CREATE_LEG_NOTE,
        payload: {
            legId,
            body,
            tripId
        },
    };
};

export const editLegNote = (legId, noteId, body, tripId) => {
    return {
        type: EDIT_LEG_NOTE,
        payload: {
            legId,
            noteId,
            body,
            tripId
        },
    };
};

export const deleteLegNote = (legId, noteId, tripId) => {
    return {
        type: DELETE_LEG_NOTE,
        payload: {
            legId,
            noteId,
            tripId,
        },
    };
};


/** End */
